import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FiGithub, FiExternalLink, FiSearch } from 'react-icons/fi';
import { publicAPI } from '../services/api';
import { generateImageUrl, truncateText } from '../utils/helpers';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import SectionHeader from '../components/common/SectionHeader';
import LoadingSpinner from '../components/common/LoadingSpinner';
import './Projects.css';

const filters = ['All', '.NET', 'Blazor', 'Angular', 'React', 'SQL', 'Broadcast', 'Automation'];

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState('All');
  const [search, setSearch] = useState('');
  const [ref, isVisible] = useScrollAnimation();

  useEffect(() => {
    publicAPI.getProjects()
      .then(res => { if (res.success) setProjects(res.data); })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const filtered = projects.filter(p => {
    const matchFilter = activeFilter === 'All' || p.technologies?.toLowerCase().includes(activeFilter.toLowerCase());
    const matchSearch = !search || p.title.toLowerCase().includes(search.toLowerCase()) ||
      p.description.toLowerCase().includes(search.toLowerCase());
    return matchFilter && matchSearch;
  });

  return (
    <section className="section projects-page">
      <Helmet><title>Projects | Deepak Chauhan</title></Helmet>
      <div className="container">
        <SectionHeader title="My Projects" subtitle="A collection of projects I've built" />

        <div className="projects-toolbar">
          <div className="project-filters">
            {filters.map(f => (
              <button key={f} className={`filter-btn ${activeFilter === f ? 'active' : ''}`}
                onClick={() => setActiveFilter(f)}>{f}</button>
            ))}
          </div>
          <div className="search-bar">
            <FiSearch />
            <input type="text" placeholder="Search projects..." value={search}
              onChange={e => setSearch(e.target.value)} />
          </div>
        </div>

        {loading ? <LoadingSpinner /> : (
          <div className={`projects-grid ${isVisible ? 'fade-in' : ''}`}>
            {filtered.map(p => (
              <div key={p.id} className="project-card card">
                <div className="project-card-image">
                  <img src={generateImageUrl(p.thumbnailUrl)} alt={p.title} />
                  <div className="project-card-overlay">
                    <Link to={`/projects/${p.slug}`} className="btn btn-primary">Details</Link>
                  </div>
                  <span className={`project-status ${p.status?.toLowerCase()}`}>{p.status}</span>
                </div>
                <div className="project-card-body">
                  <h3>{p.title}</h3>
                  <p>{truncateText(p.shortDescription || p.description, 120)}</p>
                  <div className="project-card-tech">
                    {p.technologies?.split(',').slice(0, 4).map(t => (
                      <span key={t} className="tech-badge">{t.trim()}</span>
                    ))}
                  </div>
                  <div className="project-card-links">
                    {p.githubUrl && <a href={p.githubUrl} target="_blank" rel="noreferrer"><FiGithub /></a>}
                    {p.liveDemoUrl && <a href={p.liveDemoUrl} target="_blank" rel="noreferrer"><FiExternalLink /></a>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Projects;
